



















































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { checkMobile } from "../../utils/utils";
import Subscription from "../../../api/v2/models/subscription";
import { subscriptionState } from "../../stores/subscription";
import { userState } from "../../stores/user";
import { headerState } from "../../stores/header";
import { footerState } from "../../stores/footer";
import { ROUTER_NAME } from "../../router";
import SubscriptionComponent from "../atoms_molecules/Subscription.vue";
import CoursePurchaseComponent from "../atoms_molecules/CoursePurchase.vue";
import TicketComponent from "../atoms_molecules/Ticket.vue";
import CoursePurchase from "../../../api/v2/models/course_purchase";
import axios from "axios";

interface PremiumService {
  id: number;
  name: string;
  subscriptions: Subscription[];
}

@Component({
  components: {
    SubscriptionComponent,
    CoursePurchaseComponent,
    TicketComponent,
  },
})
export default class SubscriptionList extends Vue {
  mobile: boolean = false;
  tab: string = 'ALL';
  tickets: any[] = [];
  isLoadingTickets: boolean = false;

  get user() {
    return userState.user;
  }
  get isLoading() {
    return subscriptionState.isLoading || this.isLoadingTickets;
  }
  get errorMessage() {
    return subscriptionState.errorMessage;
  }

  created() {
    this.mobile = checkMobile();
    headerState.setTitle("購入済み");
    footerState.setFooterDefault();
    this.fetchTickets();
  }

  async fetchTickets() {
    try {
      this.isLoadingTickets = true;
      const response = await axios.get('/api/v2/meeting/tickets');
      this.tickets = response.data.payment_tickets || [];
      this.isLoadingTickets = false;
    } catch (error) {
      console.error('Failed to fetch tickets:', error);
      this.isLoadingTickets = false;
    }
  }

  breadcrumbs = [
    {
      text: "クラスルーム",
      disabled: false,
      exact: true,
      to: "/classroom/",
    },
    {
      text: "購入済み",
      disabled: false,
      exact: true,
      to: "/classroom/subscription",
    },
  ];

  get subscriptions(): Subscription[] {
    if (!this.user) {
      return [];
    }
    return this.user.subscriptions;
  }

  get noneSubscriptions(): boolean {
    return this.subscriptions.length === 0;
  }

  get coursePurchases(): CoursePurchase[] {
    if (!this.user) {
      return [];
    }
    return this.user.coursePurchases;
  }

  get nonecoursePurchases(): boolean {
    return this.coursePurchases.length === 0;
  }

  get noneTickets(): boolean {
    return this.tickets.length === 0;
  }

  toSubscriptionDetail(subscription: Subscription) {
    this.$router.push({
      name: ROUTER_NAME.SUBSCRIPTION_DETAIL,
      params: {
        subscriptionId: subscription.id.toString(),
      },
    });
  }

  toCoursePurchaseDetail(coursePurchase: CoursePurchase) {
    this.$router.push({
      name: ROUTER_NAME.COURSE_PURCHASE_DETAIL,
      params: {
        coursePurchaseId: coursePurchase.id.toString(),
      },
    });
  }
}
